export const SCROLL_AMOUNT = 200;
export const SELECTED_POINTS_LIMIT = 2;
